import * as yup from 'yup'

import { getMessage } from '../../../util/IntlMessages'

export const CULTIVARS_SCHEMA = yup.object().shape({
  materialsId: yup.string().typeError(getMessage('shouldSelectAValue')).required(getMessage('selectAMaterial')),
  cultivarsDemandTypeId: yup.string().typeError(getMessage('shouldSelectAValue')).required(getMessage('selectDemand')),
  area: yup.string().typeError(getMessage('shouldSelectAValue')).required(getMessage('area')),
  cultivarsTypeId: yup.string().typeError(getMessage('shouldSelectAValue')).required(getMessage('selectACultivarsType'))
})

export const SEARCH_CULTIVARS_HISTORY_SCHEMA = yup.object().shape({
  cultivarYear: yup
    .string()
    .typeError(getMessage('shouldSelectAValue'))
    .required(getMessage('selectYearCultivarsHistory')),
  cultivarMonth: yup
    .string()
    .typeError(getMessage('shouldSelectAValue'))
    .required(getMessage('selectMonthCultivarsHistory'))
})

export const CREATE_CULTIVARS_HISTORY_SCHEMA = yup.object().shape({
  materialsId: yup.string().typeError(getMessage('shouldSelectAValue')).required(getMessage('selectAMaterial')),
  cultivarsDemandTypeId: yup.string().typeError(getMessage('shouldSelectAValue')).required(getMessage('selectDemand')),
  area: yup.string().typeError(getMessage('shouldSelectAValue')).required(getMessage('area')),
  cultivarsTypeId: yup
    .string()
    .typeError(getMessage('shouldSelectAValue'))
    .required(getMessage('selectACultivarsType')),
  cultivarMonth: yup
    .string()
    .typeError(getMessage('shouldSelectAValue'))
    .required(getMessage('selectMonthCultivarsHistory')),
  cultivarYear: yup
    .string()
    .typeError(getMessage('shouldSelectAValue'))
    .required(getMessage('selectYearCultivarsHistory'))
})
